import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import KDSTextField, {
  TextFieldProps as KDSTextFieldProps,
} from '@decisiv/ui-components/lib/components/TextField';
import { useMemo } from 'react';

export interface TextFieldProps extends Omit<KDSTextFieldProps, 'value'> {
  name: string;
  defaultValue?: string;
  warningMessage?: string;
  suppressWarningMessage?: boolean;
}

const TextField = ({
  name,
  defaultValue,
  warningMessage,
  suppressWarningMessage,
  ...props
}: TextFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fieldError = errors[name];

  const warningMessageToApply = useMemo(() => {
    if (suppressWarningMessage) return undefined;

    return warningMessage || fieldError?.message?.toString();
  }, [fieldError, suppressWarningMessage, warningMessage]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <KDSTextField
          value={value}
          warningMessage={warningMessageToApply}
          onChange={({ target }) => onChange(target.value)}
          {...props}
        />
      )}
    />
  );
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  warningMessage: PropTypes.string,
};

TextField.defaultProps = {
  defaultValue: undefined,
  warningMessage: undefined,
};

export default TextField;
